import { getBottomDistanceForFlexReverse } from "@/utils/scroll";

export const isNearBottom = (el: HTMLElement, n: number) => {
  const offsetHeight = Math.max(el.offsetHeight, 600);
  return getBottomDistanceForFlexReverse(el) < offsetHeight * n;
};
